import React, { useEffect, useState } from 'react';

import Tab from '@material-ui/core/Tab';
import TabPanel from '@material-ui/lab/TabPanel';
import TabContext from '@material-ui/lab/TabContext';
import Tabs from '@material-ui/core/Tabs';
import AppBar from '@material-ui/core/AppBar';
import Histologia from './histologia';
import { useIntl } from 'react-intl';

function HistologiaTabs(props) {
  const intl = useIntl()
  const [currentTab, setCurrentTab] = useState('0');
  const [lamina, setLamina] = useState(false);
  const [isHtologiaLaminas, setIsHtologiaLaminas] = useState(false);

  useEffect(() => {
    setTimeout(() => setCurrentTab('1'), 200);
    setLamina(props.data.title.text.includes('Lâminas'));
    setIsHtologiaLaminas(Object.keys(props.lista).length === 4);
  }, []);

  const mudarAba = (event, tab) => setCurrentTab(tab);

  return (
    <div className='mv-solicitacoes-page'>
      <TabContext value={currentTab}>
        <AppBar position='static' color='default'>
          <Tabs
            value={currentTab}
            onChange={mudarAba}
            variant='scrollable'
            indicatorColor='primary'
            textColor='primary'
            aria-label='scrollable force tabs example'
          >
            <Tab
              label={isHtologiaLaminas && !lamina ? `${ intl.formatMessage({id:"dashboards.histology.createBlades"}) }` : `${intl.formatMessage({id:"general.materialArchiving.toMove"}) }`}
              value='1'
            />
            {!lamina && !isHtologiaLaminas && (
              <Tab label={`${ intl.formatMessage({id:"dashboards.histology.createBlades"}) }`} value='2' />
            )}

            <Tab value='0' disabled></Tab>
          </Tabs>
        </AppBar>

        <TabPanel value='0'></TabPanel>

        <TabPanel value='1'>
          {!isHtologiaLaminas && <Histologia {...props} lamina={lamina} />}
          {isHtologiaLaminas && <Histologia {...props} lamina={!lamina} />}
        </TabPanel>
        <TabPanel value='2'>
          <Histologia {...props} lamina />
        </TabPanel>
      </TabContext>
    </div>
  );
}

export default HistologiaTabs;



// WEBPACK FOOTER //
// ./src/componentes/dragdrog/containers/HistologiaTabs/index.js